import { Navigation } from "@mcleod/core";
import { AutogenLayoutManualOfficeSettlementList } from "./autogen/AutogenLayoutManualOfficeSettlementList";

export class ManualOfficeSettlementList extends AutogenLayoutManualOfficeSettlementList {
    override onLoad(): void {
        this.mainDataSource.orderBy = [{ field: "payee_id", sort: "asc" }, { field: "check_date", sort: "desc" }];

        // Wire the Print/Post button to open the Manual Office Posting screen
        this.buttonPrintPost.addClickListener(() => {
            Navigation.navigateTo("lme/settlement/reports/ManualOfficePostingReport", { newTab: true });
        });
    }
}
